import React from 'react'
import { Chip } from '@mui/material'
import { dsColorNew } from '@palette'

/**
 * One axis of a rate card, as a chip, in the colours Rate cards gives
 * each axis. Lifted out of the `EnumSelect` of Rate cards (CU-869fh646w)
 * because the "Rate cards that fit" block of the Strategies wizard shows
 * the same axes and has to look like the same thing.
 *
 * A blank axis is the white, dashed, italic chip saying "All …": since
 * this task a blank tariff type or insurance means any, like a blank
 * franchise always did. No `title` on it — what blank means is said
 * once, in the help note of Rate cards.
 */
export const AXIS_CHIP_COLORS = {
	site:      { bg: dsColorNew.pillActiveBg, fg: dsColorNew.appBlue, border: dsColorNew.noteInfoBorder },
	tariff:    { bg: dsColorNew.noteInfoBg, fg: dsColorNew.noteInfo, border: dsColorNew.noteInfoBorder },
	insurance: { bg: dsColorNew.noteAmberBg, fg: dsColorNew.noteAmber, border: dsColorNew.noteAmberBorder },
	franchise: { bg: dsColorNew.pillTrackBg, fg: dsColorNew.textDark, border: dsColorNew.grayBorder },
}

export const ALL_LABEL_BY_VARIANT = {
	site:      'All sites',
	tariff:    'All tariff types',
	insurance: 'All insurance',
	franchise: 'All franchises',
}

const labelSx = {
	'& .MuiChip-label': { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
}

export default function AxisChip({ variant, label, blank = false, sx = {} }) {
	const colors = AXIS_CHIP_COLORS[variant] || AXIS_CHIP_COLORS.franchise
	if (blank) {
		return (
			<Chip size="small"
			      label={label ?? ALL_LABEL_BY_VARIANT[variant] ?? 'All'}
			      sx={{ height: 22, fontWeight: 700, fontSize: 11,
			            letterSpacing: '0.02em', maxWidth: '100%',
			            bgcolor: dsColorNew.white, color: dsColorNew.textMuted,
			            border: '1px dashed', borderColor: dsColorNew.textSubtle,
			            fontStyle: 'italic', ...labelSx, ...sx }}/>
		)
	}
	return (
		<Chip size="small" label={label}
		      sx={{ height: 22, fontWeight: 700, fontSize: 11, maxWidth: '100%',
		            bgcolor: colors.bg, color: colors.fg,
		            border: '1px solid', borderColor: colors.border, ...labelSx, ...sx }}/>
	)
}
